import { useEffect, useState } from 'react'
import { NavLink, Route, Routes } from 'react-router-dom'

import { enregistrerBattement } from '../db/repo'
import { appliquerMiseAJour, onMiseAJour } from '../pwa/register'
import { IconeListe, IconeLune, IconeReglages, IconeStats } from './composants'
import { PageAujourdhui } from './pages/Aujourdhui'
import { PageInstallation } from './pages/Installation'
import { PageNuit } from './pages/Nuit'
import { PageNuits } from './pages/Nuits'
import { PageReglages } from './pages/Reglages'
import { PageStatistiques } from './pages/Statistiques'
import { PageSync } from './pages/Sync'

function BandeauMiseAJour() {
  const [pret, setPret] = useState(false)
  const [enCours, setEnCours] = useState(false)

  useEffect(() => onMiseAJour(setPret), [])

  if (!pret) return null
  return (
    <div className="bandeau-maj" role="status">
      <span className="grandir">Une nouvelle version est prête.</span>
      <button
        type="button"
        className="btn btn--petit"
        disabled={enCours}
        onClick={() => {
          setEnCours(true)
          void appliquerMiseAJour()
        }}
      >
        {enCours ? 'Mise à jour…' : 'Recharger'}
      </button>
    </div>
  )
}

/**
 * Battement d'activite, seule source du repli heuristique.
 *
 * Il n'enregistre que lorsque l'app est **visible** : sur iOS le JS est gele
 * quelques secondes apres le passage en arriere-plan, un minuteur qui
 * continuerait de tourner en fond n'existe pas. C'est aussi ce qui donne son
 * sens a la mesure — « l'app etait au premier plan a cet instant ».
 */
function useBattement() {
  useEffect(() => {
    const battre = () => {
      if (document.visibilityState === 'visible') void enregistrerBattement()
    }
    battre()
    const minuteur = window.setInterval(battre, 60_000)
    document.addEventListener('visibilitychange', battre)
    return () => {
      window.clearInterval(minuteur)
      document.removeEventListener('visibilitychange', battre)
    }
  }, [])
}

export function App() {
  useBattement()

  return (
    <div className="app">
      <BandeauMiseAJour />
      <Routes>
        <Route path="/" element={<PageAujourdhui />} />
        <Route path="/nuits" element={<PageNuits />} />
        <Route path="/nuits/nouvelle" element={<PageNuit />} />
        <Route path="/nuits/:date" element={<PageNuit />} />
        <Route path="/statistiques" element={<PageStatistiques />} />
        <Route path="/reglages" element={<PageReglages />} />
        <Route path="/installation" element={<PageInstallation />} />
        {/* La charge utile des raccourcis voyage dans le fragment : elle n'est
            jamais transmise au serveur, donc jamais journalisee par Apache. */}
        <Route path="/sync/:payload" element={<PageSync />} />
        <Route path="/sync" element={<PageSync />} />
        <Route path="*" element={<PageAujourdhui />} />
      </Routes>

      <nav className="onglets" aria-label="Navigation principale">
        <NavLink to="/" className="onglet" end>
          <IconeLune />
          Nuit
        </NavLink>
        <NavLink to="/nuits" className="onglet">
          <IconeListe />
          Journal
        </NavLink>
        <NavLink to="/statistiques" className="onglet">
          <IconeStats />
          Stats
        </NavLink>
        <NavLink to="/reglages" className="onglet">
          <IconeReglages />
          Réglages
        </NavLink>
      </nav>
    </div>
  )
}
